import { render, staticRenderFns } from "./basesIcon.vue?vue&type=template&id=a479e93a&"
import script from "./basesIcon.vue?vue&type=script&lang=js&"
export * from "./basesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports